/**
 * RESPONSIBILITY: draw the church's mark at the top of every page.
 *
 * The logo if there is one, and the cross if there is not — a church with no logo
 * uploaded yet still has a brand in the corner.
 *
 * AND THE CROSS AGAIN IF THE LOGO WILL NOT LOAD. A stored path can outlive its file:
 * that is what a deploy used to do to every upload, and it left an empty 192-pixel gap
 * where the church's name should be, on every page, with nothing to say why. A picture
 * that fails is a picture that is not there, and the page already knows what to draw
 * when there is not one.
 */
import { useState } from 'react';
import type { ImageValue } from '@framework/core';

export function BrandMark({ logo, name }: { logo: ImageValue | undefined; name: string }) {
  const [broken, setBroken] = useState(false);

  if (!logo || broken) return <span className="brand-mark" aria-hidden="true">✝</span>;

  return (
    <img
      className="brand-logo" src={logo.path} alt={logo.alt || name}
      onError={() => setBroken(true)}
    />
  );
}
